export default __webpack_public_path__ + "static/media/withdrawal-bite.aba575d2.svg";